// @flow

import Decimal from 'decimal.js';

import type { GridItem } from '../types';
import { getCombinedCasesAndBottlesInBottles } from './getCombinedCasesAndBottlesInBottles';
import { convertBottlesToQty } from './convertBottlesToQty';
import { getBottlesFromQty } from './getBottlesFromQty';
import { getCasesFromQty } from './getCasesFromQty';

const updateGridAfterEdit = (item: GridItem) => {
  if (
    item.maxItemQty &&
    item.maxItemQty.ActionPerOrderType &&
    item.maxItemQty.ActionPerOrderType === 'update'
  ) {
    item.maxItemQty.ActionPerOrderType = 'none';
  }
};

const priceUpdater = ({ Price }: { Price: number }) => (item: GridItem) => {
  item.Price.value = Price;
};

const previousQtyUpdater = ({
  Cases,
  Bottles,
  OrderType,
}: {
  Cases: number,
  Bottles: number,
}) => (item: GridItem) => {
  if (item.maxItemQty && item.maxItemQty.PreviousAdd) {
    const { PreviousAdd, byOrderType } = item.maxItemQty;
    const casesToBottles = item.Uom && Cases * item.Uom;
    const totalSent = casesToBottles + Bottles;
    // This is gonna be the new Qty for the item so instead of using
    // PreviousAdd for updating `byOrderType` we'll use this instead
    // since it represents the most up to date Qty.
    const newQty = convertBottlesToQty(totalSent, item.Uom);

    const updatedByOrderType = byOrderType.map(maxQtyItem => {
      const { Qty } = maxQtyItem;

      if (Qty === 0 && newQty >= PreviousAdd.Qty) {
        return maxQtyItem;
      }

      const qtyInBottles = getCombinedCasesAndBottlesInBottles(Qty, item.Uom);

      const prevQtyInBottles = getCombinedCasesAndBottlesInBottles(
        PreviousAdd.Qty,
        item.Uom,
      );

      const diffBetweenPrevAddAndCurrentAdd = Decimal.sub(
        prevQtyInBottles,
        totalSent,
      );

      const updatedQtyInBottles = Decimal.add(
        qtyInBottles,
        diffBetweenPrevAddAndCurrentAdd,
      );

      const updatedQty = convertBottlesToQty(updatedQtyInBottles, item.Uom);

      return {
        id: maxQtyItem.id,
        Qty: updatedQty,
        Cases: getCasesFromQty(updatedQty),
        Bottles: getBottlesFromQty(updatedQty, item.Uom),
      };
    });

    // `totalSent === 0` means that the user is deleting the item
    if (totalSent === 0) {
      // $FlowFixMe
      item.maxItemQty = {
        byOrderType: updatedByOrderType,
        PreviousAdd: {
          Qty: 0,
          Cases: 0,
          Bottles: 0,
        },
      };
    } else {
      // $FlowFixMe
      item.maxItemQty = {
        byOrderType: updatedByOrderType,
        PreviousAdd: {
          Qty: convertBottlesToQty(totalSent, item.Uom),
          Cases,
          Bottles,
        },
      };
    }
  }
};

export { updateGridAfterEdit, priceUpdater, previousQtyUpdater };
